export function removeItem(array, item) {
    array.splice(array.indexOf(item), 1);
}
export function unconcat(array, item) {
    const clonedArray = [...array];
    removeItem(clonedArray, item);
    return clonedArray;
}
export function split(array, chunkSize) {
    return array.reduce((result, item, index) => {
        const chunkIndex = Math.floor(index / chunkSize);
        if (!result[chunkIndex]) {
            result[chunkIndex] = [];
        }
        result[chunkIndex].push(item);
        return result;
    }, []);
}
